const storage = {
    not_configured: 'Depolama sağlayıcısı yapılandırılmamış.',
    missing_parameter: 'Depolama sağlayıcısı için eksik parametre {{parameter}}.',
    upload_error: 'Dosya yüklenemedi.',
};
export default storage;
